
/**
 * Determines if a given event date is in the future.
 *
 * @param {number} eventDate - The event date in seconds since the Unix epoch.
 * @returns {boolean} True if the event date is in the future, false otherwise.
 */


export const isFutureDate = (eventDate) => {

  const eventDateMS = eventDate * 1000;
  const todayDateObject = Date.now();

  if (eventDateMS > todayDateObject) {
    return true;
  } else {
    return false;
  }
};
